
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $5c802cafad583260$exports = {};
!function(e, t) {
    $5c802cafad583260$exports = t();
}($5c802cafad583260$exports, function() {
    return function(e) {
        function t(o) {
            if (n[o]) return n[o].exports;
            var i = n[o] = {
                exports: {},
                id: o,
                loaded: !1
            };
            return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.p = "dist/", t(0);
    }([
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var i = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
                }
                return e;
            }, r = n(1), a = (o(r), n(6)), u = o(a), c = n(7), s = o(c), f = n(8), d = o(f), l = n(9), p = o(l), m = n(10), b = o(m), v = n(11), y = o(v), g = n(14), h = o(g), w = [], k = !1, x = {
                offset: 120,
                delay: 0,
                easing: "ease",
                duration: 400,
                disable: !1,
                once: !1,
                startEvent: "DOMContentLoaded",
                throttleDelay: 99,
                debounceDelay: 50,
                disableMutationObserver: !1
            }, j = function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
            }, O = function() {
                w = (0, h.default)(), j();
            }, M = function() {
                w.forEach(function(e, t) {
                    e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
                });
            }, S = function(e) {
                return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
            }, _ = function(e) {
                x = i(x, e), w = (0, h.default)();
                var t = document.all && !window.atob;
                return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && [
                    "complete",
                    "interactive"
                ].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function() {
                    j(!0);
                }) : document.addEventListener(x.startEvent, function() {
                    j(!0);
                }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function() {
                    (0, b.default)(w, x.once);
                }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
            };
            e.exports = {
                init: _,
                refresh: j,
                refreshHard: O
            };
        },
        function(e, t) {},
        ,
        ,
        ,
        ,
        function(e, t) {
            (function(t) {
                "use strict";
                function n(e, t, n) {
                    function o(t) {
                        var n = b, o = v;
                        return b = v = void 0, k = t, g = e.apply(o, n);
                    }
                    function r(e) {
                        return k = e, h = setTimeout(f, t), M ? o(e) : g;
                    }
                    function a(e) {
                        var n = e - w, o = e - k, i = t - n;
                        return S ? j(i, y - o) : i;
                    }
                    function c(e) {
                        var n = e - w, o = e - k;
                        return void 0 === w || n >= t || n < 0 || S && o >= y;
                    }
                    function f() {
                        var e = O();
                        return c(e) ? d(e) : void (h = setTimeout(f, a(e)));
                    }
                    function d(e) {
                        return h = void 0, _ && b ? o(e) : (b = v = void 0, g);
                    }
                    function l() {
                        void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
                    }
                    function p() {
                        return void 0 === h ? g : d(O());
                    }
                    function m() {
                        var e = O(), n = c(e);
                        if (b = arguments, v = this, w = e, n) {
                            if (void 0 === h) return r(w);
                            if (S) return h = setTimeout(f, t), o(w);
                        }
                        return void 0 === h && (h = setTimeout(f, t)), g;
                    }
                    var b, v, y, g, h, w, k = 0, M = !1, S = !1, _ = !0;
                    if ("function" != typeof e) throw new TypeError(s);
                    return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
                }
                function o(e, t, o) {
                    var r = !0, a = !0;
                    if ("function" != typeof e) throw new TypeError(s);
                    return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, {
                        leading: r,
                        maxWait: t,
                        trailing: a
                    });
                }
                function i(e) {
                    var t = "undefined" == typeof e ? "undefined" : c(e);
                    return !!e && ("object" == t || "function" == t);
                }
                function r(e) {
                    return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
                }
                function a(e) {
                    return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
                }
                function u(e) {
                    if ("number" == typeof e) return e;
                    if (a(e)) return f;
                    if (i(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = i(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(l, "");
                    var n = m.test(e);
                    return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e;
                }
                var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, s = "Expected a function", f = NaN, d = "[object Symbol]", l = /^\s+|\s+$/g, p = /^[-+]0x[0-9a-f]+$/i, m = /^0b[01]+$/i, b = /^0o[0-7]+$/i, v = parseInt, y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t, g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self, h = y || g || Function("return this")(), w = Object.prototype, k = w.toString, x = Math.max, j = Math.min, O = function() {
                    return h.Date.now();
                };
                e.exports = o;
            }).call(t, function() {
                return this;
            }());
        },
        function(e, t) {
            (function(t) {
                "use strict";
                function n(e, t, n) {
                    function i(t) {
                        var n = b, o = v;
                        return b = v = void 0, O = t, g = e.apply(o, n);
                    }
                    function r(e) {
                        return O = e, h = setTimeout(f, t), M ? i(e) : g;
                    }
                    function u(e) {
                        var n = e - w, o = e - O, i = t - n;
                        return S ? x(i, y - o) : i;
                    }
                    function s(e) {
                        var n = e - w, o = e - O;
                        return void 0 === w || n >= t || n < 0 || S && o >= y;
                    }
                    function f() {
                        var e = j();
                        return s(e) ? d(e) : void (h = setTimeout(f, u(e)));
                    }
                    function d(e) {
                        return h = void 0, _ && b ? i(e) : (b = v = void 0, g);
                    }
                    function l() {
                        void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
                    }
                    function p() {
                        return void 0 === h ? g : d(j());
                    }
                    function m() {
                        var e = j(), n = s(e);
                        if (b = arguments, v = this, w = e, n) {
                            if (void 0 === h) return r(w);
                            if (S) return h = setTimeout(f, t), i(w);
                        }
                        return void 0 === h && (h = setTimeout(f, t)), g;
                    }
                    var b, v, y, g, h, w, O = 0, M = !1, S = !1, _ = !0;
                    if ("function" != typeof e) throw new TypeError(c);
                    return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
                }
                function o(e) {
                    var t = "undefined" == typeof e ? "undefined" : u(e);
                    return !!e && ("object" == t || "function" == t);
                }
                function i(e) {
                    return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
                }
                function r(e) {
                    return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f;
                }
                function a(e) {
                    if ("number" == typeof e) return e;
                    if (r(e)) return s;
                    if (o(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = o(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(d, "");
                    var n = p.test(e);
                    return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e;
                }
                var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, c = "Expected a function", s = NaN, f = "[object Symbol]", d = /^\s+|\s+$/g, l = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, m = /^0o[0-7]+$/i, b = parseInt, v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t, y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self, g = v || y || Function("return this")(), h = Object.prototype, w = h.toString, k = Math.max, x = Math.min, j = function() {
                    return g.Date.now();
                };
                e.exports = n;
            }).call(t, function() {
                return this;
            }());
        },
        function(e, t) {
            "use strict";
            function n(e) {
                var t = void 0, o = void 0, i = void 0;
                for(t = 0; t < e.length; t += 1){
                    if (o = e[t], o.dataset && o.dataset.aos) return !0;
                    if (i = o.children && n(o.children)) return !0;
                }
                return !1;
            }
            function o() {
                return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            }
            function i() {
                return !!o();
            }
            function r(e, t) {
                var n = window.document, i = o(), r = new i(a);
                u = t, r.observe(n.documentElement, {
                    childList: !0,
                    subtree: !0,
                    removedNodes: !0
                });
            }
            function a(e) {
                e && e.forEach(function(e) {
                    var t = Array.prototype.slice.call(e.addedNodes), o = Array.prototype.slice.call(e.removedNodes), i = t.concat(o);
                    if (n(i)) return u();
                });
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var u = function() {};
            t.default = {
                isSupported: i,
                ready: r
            };
        },
        function(e, t) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function o() {
                return navigator.userAgent || navigator.vendor || window.opera || "";
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                    }
                }
                return function(t, n, o) {
                    return n && e(t.prototype, n), o && e(t, o), t;
                };
            }(), r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, s = function() {
                function e() {
                    n(this, e);
                }
                return i(e, [
                    {
                        key: "phone",
                        value: function() {
                            var e = o();
                            return !(!r.test(e) && !a.test(e.substr(0, 4)));
                        }
                    },
                    {
                        key: "mobile",
                        value: function() {
                            var e = o();
                            return !(!u.test(e) && !c.test(e.substr(0, 4)));
                        }
                    },
                    {
                        key: "tablet",
                        value: function() {
                            return this.mobile() && !this.phone();
                        }
                    }
                ]), e;
            }();
            t.default = new s;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e, t, n) {
                var o = e.node.getAttribute("data-aos-once");
                t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !n && "true" !== o) && e.node.classList.remove("aos-animate");
            }, o = function(e, t) {
                var o = window.pageYOffset, i = window.innerHeight;
                e.forEach(function(e, r) {
                    n(e, i + o, t);
                });
            };
            t.default = o;
        },
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(12), r = o(i), a = function(e, t) {
                return e.forEach(function(e, n) {
                    e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
                }), e;
            };
            t.default = a;
        },
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(13), r = o(i), a = function(e, t) {
                var n = 0, o = 0, i = window.innerHeight, a = {
                    offset: e.getAttribute("data-aos-offset"),
                    anchor: e.getAttribute("data-aos-anchor"),
                    anchorPlacement: e.getAttribute("data-aos-anchor-placement")
                };
                switch(a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement){
                    case "top-bottom":
                        break;
                    case "center-bottom":
                        n += e.offsetHeight / 2;
                        break;
                    case "bottom-bottom":
                        n += e.offsetHeight;
                        break;
                    case "top-center":
                        n += i / 2;
                        break;
                    case "bottom-center":
                        n += i / 2 + e.offsetHeight;
                        break;
                    case "center-center":
                        n += i / 2 + e.offsetHeight / 2;
                        break;
                    case "top-top":
                        n += i;
                        break;
                    case "bottom-top":
                        n += e.offsetHeight + i;
                        break;
                    case "center-top":
                        n += e.offsetHeight / 2 + i;
                }
                return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
            };
            t.default = a;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e) {
                for(var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
                return {
                    top: n,
                    left: t
                };
            };
            t.default = n;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e) {
                return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function(e) {
                    return {
                        node: e
                    };
                });
            };
            t.default = n;
        }
    ]);
});




function $cecc98bcb04b03e8$export$bb046b82f0ab01e2() {
    if (window.scrollY > 400) {
        document.getElementById("go-to-top").classList.remove("hidden");
        document.getElementById("go-to-top").classList.add("flex");
    } else {
        document.getElementById("go-to-top").classList.remove("flex");
        document.getElementById("go-to-top").classList.add("hidden");
    }
}


function $e73e8b8d99025aa5$export$2ac64a422d3a9b85() {
    document.getElementById("appointment-form").addEventListener("submit", function(event) {
        event.preventDefault(); // Prevent the default form submission
        // Get input values
        const first_name = document.getElementById("first_name").value;
        const last_name = document.getElementById("last_name").value;
        const email = document.getElementById("email").value;
        const isd = document.getElementById("isd-code").value;
        const phone_number = document.getElementById("phone").value;
        const phone = isd + " " + phone_number;
        const state = document.getElementById("state").value;
        const country = document.getElementById("country").value;
        const message = document.getElementById("message").value;
        console.log(phone);
        // Create a data object to send
        const data = {
            FirstName: first_name,
            LastName: last_name,
            Email: email,
            PhoneNumber: phone,
            State: state,
            Country: country,
            Message: message
        };
        console.log(data);
        // Send a POST request using Fetch API
        fetch("SaveAppointment.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data) // Convert data object to JSON string
        }).then((response)=>{
            if (!response.ok) throw new Error("Network response was not ok " + response.statusText);
            return response.json(); // Parse JSON response
        }).then((data)=>{
            // Handle success response
            console.log("Success:", data);
            // alert('Your appointment has been booked successfully!');
            // Optionally, you can clear the form or redirect
            if (data.errors) {
                document.getElementById("err-message-window").classList.remove("hidden");
                document.getElementById("err-message-window").classList.add("block");
                document.getElementById("err-message-content").innerHTML = data.errors;
            } else {
                document.getElementById("appointment-form").reset();
                document.getElementById("appointment-window").classList.add("hidden");
                document.getElementById("message-window").classList.remove("hidden");
                document.getElementById("message-window").classList.add("block");
                setTimeout(()=>{
                    document.getElementById("message-window").classList.remove("block");
                    document.getElementById("message-window").classList.add("hidden");
                }, 5000);
            }
        }).catch((error)=>{
            // Handle error response
            console.error("Error:", error);
            alert("There was an error creating the sub-admin. Please try again.");
        });
    });
    document.getElementById("err-message-window-closer").addEventListener("click", ()=>{
        document.getElementById("err-message-window").classList.add("hidden");
        document.getElementById("err-message-window").classList.remove("block");
    });
}


function $7b2c18e151864ac9$export$7f1e8f51b61dd57() {
    //code for navigation
    const navs = document.querySelectorAll(".navigation");
    //code for resetting menu
    function resetMenu() {
        menu.classList.add("hidden");
        menu.classList.remove("block");
        menu_btn.classList.remove("fa-xmark");
        menu_btn.classList.add("fa-bars");
        menuexpand = false;
    }
    navs.forEach((nav)=>{
        nav.addEventListener("click", (e)=>{
            e.preventDefault();
            const hash = e.target.textContent;
            switch(hash){
                case "Home":
                    window.location.href = "";
                    resetMenu();
                    break;
                case "About Us":
                    window.location.href = "about";
                    resetMenu();
                    break;
                case "Payment":
                    window.location.href = "payment-qr";
                    resetMenu();
                    break;
                case "Contact Us":
                    window.location.href = "contact-us";
                    resetMenu();
                    break;
                default:
                    break;
            }
        });
    });
}


function $d446e4ddd49a1d1e$export$1bfdc901caf271be(maxNumber) {
    let currentCount = 0;
    const counterElement = document.getElementById("p-counter");
    const interval = setInterval(()=>{
        if (currentCount < maxNumber) {
            currentCount += 100;
            counterElement.innerText = currentCount;
        } else clearInterval(interval);
    }, 50); // Adjust the delay (in milliseconds) as needed
}
function $d446e4ddd49a1d1e$export$e6ef8bb00b365fd7(maxNumber) {
    let currentCount = 0;
    const counterElement = document.getElementById("c-counter");
    const interval = setInterval(()=>{
        if (currentCount < maxNumber) {
            currentCount++;
            counterElement.innerText = currentCount;
        } else clearInterval(interval);
    }, 100); // Adjust the delay (in milliseconds) as needed
}
function $d446e4ddd49a1d1e$export$e951be9369cbe7b1(targetElement, counterFunction, maxNumber) {
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                counterFunction(maxNumber); // Change this number as needed
                observer.unobserve(entry.target); // Stop observing once it has counted
            }
        });
    });
    observer.observe(targetElement);
}


function $96c4986fcc3c58c1$export$2e2bcd8739ae039() {
    let disease_links = Array.from(document.getElementsByClassName("disease-link-list"));
    disease_links.forEach((link)=>{
        link.addEventListener("click", ()=>{
            let disease = link.getAttribute("link");
            window.location.href = `${disease}`;
        });
    });
}


function $9bec2756522502d7$export$2e2bcd8739ae039() {
    // Get the two select elements
    const countrySelect = document.getElementById("country");
    const codeSelect = document.getElementById("isd-code");
    // Map countries to their respective country codes
    const countryCodeMap = {
        "Afghanistan": "+93",
        "Albania": "+355",
        "Algeria": "+213",
        "Andorra": "+376",
        "Angola": "+244",
        "Antigua and Barbuda": "+1-268",
        "Argentina": "+54",
        "Armenia": "+374",
        "Australia": "+61",
        "Austria": "+43",
        "Azerbaijan": "+994",
        "Bahamas": "+1-242",
        "Bahrain": "+973",
        "Bangladesh": "+880",
        "Barbados": "+1-246",
        "Belarus": "+375",
        "Belgium": "+32",
        "Belize": "+501",
        "Benin": "+229",
        "Bhutan": "+975",
        "Bolivia": "+591",
        "Bosnia and Herzegovina": "+387",
        "Botswana": "+267",
        "Brazil": "+55",
        "Brunei": "+673",
        "Bulgaria": "+359",
        "Burkina Faso": "+226",
        "Burundi": "+257",
        "Cabo Verde": "+238",
        "Cambodia": "+855",
        "Cameroon": "+237",
        "Canada": "+1",
        "Central African Republic": "+236",
        "Chile": "+56",
        "China": "+86",
        "Colombia": "+57",
        "Comoros": "+269",
        "Congo": "+242",
        "Costa Rica": "+506",
        "Croatia": "+385",
        "Cuba": "+53",
        "Cyprus": "+357",
        "Czech Republic": "+420",
        "Democratic Republic of the Congo": "+243",
        "Denmark": "+45",
        "Djibouti": "+253",
        "Dominica": "+1-767",
        "Dominican Republic": "+1-809",
        "Ecuador": "+593",
        "Egypt": "+20",
        "El Salvador": "+503",
        "Equatorial Guinea": "+240",
        "Eritrea": "+291",
        "Estonia": "+372",
        "Eswatini": "+268",
        "Ethiopia": "+251",
        "Fiji": "+679",
        "Finland": "+358",
        "France": "+33",
        "Gabon": "+241",
        "Gambia": "+220",
        "Georgia": "+995",
        "Germany": "+49",
        "Ghana": "+233",
        "Greece": "+30",
        "Grenada": "+1-473",
        "Guatemala": "+502",
        "Guinea": "+224",
        "Guinea-Bissau": "+245",
        "Guyana": "+592",
        "Haiti": "+509",
        "Honduras": "+504",
        "Hungary": "+36",
        "Iceland": "+354",
        "India": "+91",
        "Indonesia": "+62",
        "Iran": "+98",
        "Iraq": "+964",
        "Ireland": "+353",
        "Israel": "+972",
        "Italy": "+39",
        "Ivory Coast": "+225",
        "Jamaica": "+1-876",
        "Japan": "+81",
        "Jordan": "+962",
        "Kazakhstan": "+7",
        "Kenya": "+254",
        "Kiribati": "+686",
        "Kosovo": "+383",
        "Kuwait": "+965",
        "Kyrgyzstan": "+996",
        "Laos": "+856",
        "Latvia": "+371",
        "Lebanon": "+961",
        "Lesotho": "+266",
        "Liberia": "+231",
        "Libya": "+218",
        "Liechtenstein": "+423",
        "Lithuania": "+370",
        "Luxembourg": "+352",
        "Madagascar": "+261",
        "Malawi": "+265",
        "Malaysia": "+60",
        "Maldives": "+960",
        "Mali": "+223",
        "Malta": "+356",
        "Marshall Islands": "+692",
        "Mauritania": "+222",
        "Mauritius": "+230",
        "Mexico": "+52",
        "Micronesia": "+691",
        "Moldova": "+373",
        "Monaco": "+377",
        "Mongolia": "+976",
        "Montenegro": "+382",
        "Morocco": "+212",
        "Mozambique": "+258",
        "Myanmar": "+95",
        "Namibia": "+264",
        "Nauru": "+674",
        "Nepal": "+977",
        "Netherlands": "+31",
        "New Zealand": "+64",
        "Nicaragua": "+505",
        "Niger": "+227",
        "Nigeria": "+234",
        "North Korea": "+850",
        "North Macedonia": "+389",
        "Norway": "+47",
        "Oman": "+968",
        "Pakistan": "+92",
        "Palau": "+680",
        "Panama": "+507",
        "Papua New Guinea": "+675",
        "Paraguay": "+595",
        "Peru": "+51",
        "Philippines": "+63",
        "Poland": "+48",
        "Portugal": "+351",
        "Qatar": "+974",
        "Romania": "+40",
        "Russia": "+7",
        "Rwanda": "+250",
        "Saint Kitts and Nevis": "+1-869",
        "Saint Lucia": "+1-758",
        "Saint Vincent and the Grenadines": "+1-784",
        "Samoa": "+685",
        "San Marino": "+378",
        "Sao Tome and Principe": "+239",
        "Saudi Arabia": "+966",
        "Senegal": "+221",
        "Serbia": "+381",
        "Seychelles": "+248",
        "Sierra Leone": "+232",
        "Singapore": "+65",
        "Slovakia": "+421",
        "Slovenia": "+386",
        "Solomon Islands": "+677",
        "Somalia": "+252",
        "South Africa": "+27",
        "South Korea": "+82",
        "South Sudan": "+211",
        "Spain": "+34",
        "Sri Lanka": "+94",
        "Sudan": "+249",
        "Suriname": "+597",
        "Sweden": "+46",
        "Switzerland": "+41",
        "Syria": "+963",
        "Taiwan": "+886",
        "Tajikistan": "+992",
        "Tanzania": "+255",
        "Thailand": "+66",
        "Timor-Leste": "+670",
        "Togo": "+228",
        "Tonga": "+676",
        "Trinidad and Tobago": "+1-868",
        "Tunisia": "+216",
        "Turkmenistan": "+993",
        "Turkey": "+90",
        "Tuvalu": "+688",
        "Uganda": "+256",
        "Ukraine": "+380",
        "United Arab Emirates": "+971",
        "United Kingdom": "+44",
        "United States": "+1",
        "Uruguay": "+598",
        "Uzbekistan": "+998",
        "Vanuatu": "+678",
        "Venezuela": "+58",
        "Vietnam": "+84",
        "Yemen": "+967",
        "Zambia": "+260",
        "Zimbabwe": "+263"
    };
    const swappedCountryCodeMap = {
        "+93": "Afghanistan",
        "+355": "Albania",
        "+213": "Algeria",
        "+376": "Andorra",
        "+244": "Angola",
        "+1-268": "Antigua and Barbuda",
        "+54": "Argentina",
        "+374": "Armenia",
        "+61": "Australia",
        "+43": "Austria",
        "+994": "Azerbaijan",
        "+1-242": "Bahamas",
        "+973": "Bahrain",
        "+880": "Bangladesh",
        "+1-246": "Barbados",
        "+375": "Belarus",
        "+32": "Belgium",
        "+501": "Belize",
        "+229": "Benin",
        "+975": "Bhutan",
        "+591": "Bolivia",
        "+387": "Bosnia and Herzegovina",
        "+267": "Botswana",
        "+55": "Brazil",
        "+673": "Brunei",
        "+359": "Bulgaria",
        "+226": "Burkina Faso",
        "+257": "Burundi",
        "+238": "Cabo Verde",
        "+855": "Cambodia",
        "+237": "Cameroon",
        "+1": "Canada",
        "+236": "Central African Republic",
        "+56": "Chile",
        "+86": "China",
        "+57": "Colombia",
        "+269": "Comoros",
        "+242": "Congo",
        "+506": "Costa Rica",
        "+385": "Croatia",
        "+53": "Cuba",
        "+357": "Cyprus",
        "+420": "Czech Republic",
        "+243": "Democratic Republic of the Congo",
        "+45": "Denmark",
        "+253": "Djibouti",
        "+1-767": "Dominica",
        "+1-809": "Dominican Republic",
        "+593": "Ecuador",
        "+20": "Egypt",
        "+503": "El Salvador",
        "+240": "Equatorial Guinea",
        "+291": "Eritrea",
        "+372": "Estonia",
        "+268": "Eswatini",
        "+251": "Ethiopia",
        "+679": "Fiji",
        "+358": "Finland",
        "+33": "France",
        "+241": "Gabon",
        "+220": "Gambia",
        "+995": "Georgia",
        "+49": "Germany",
        "+233": "Ghana",
        "+30": "Greece",
        "+1-473": "Grenada",
        "+502": "Guatemala",
        "+224": "Guinea",
        "+245": "Guinea-Bissau",
        "+592": "Guyana",
        "+509": "Haiti",
        "+504": "Honduras",
        "+36": "Hungary",
        "+354": "Iceland",
        "+91": "India",
        "+62": "Indonesia",
        "+98": "Iran",
        "+964": "Iraq",
        "+353": "Ireland",
        "+972": "Israel",
        "+39": "Italy",
        "+225": "Ivory Coast",
        "+1-876": "Jamaica",
        "+81": "Japan",
        "+962": "Jordan",
        "+7": "Kazakhstan",
        "+254": "Kenya",
        "+686": "Kiribati",
        "+383": "Kosovo",
        "+965": "Kuwait",
        "+996": "Kyrgyzstan",
        "+856": "Laos",
        "+371": "Latvia",
        "+961": "Lebanon",
        "+266": "Lesotho",
        "+231": "Liberia",
        "+218": "Libya",
        "+423": "Liechtenstein",
        "+370": "Lithuania",
        "+352": "Luxembourg",
        "+261": "Madagascar",
        "+265": "Malawi",
        "+60": "Malaysia",
        "+960": "Maldives",
        "+223": "Mali",
        "+356": "Malta",
        "+692": "Marshall Islands",
        "+222": "Mauritania",
        "+230": "Mauritius",
        "+52": "Mexico",
        "+691": "Micronesia",
        "+373": "Moldova",
        "+377": "Monaco",
        "+976": "Mongolia",
        "+382": "Montenegro",
        "+212": "Morocco",
        "+258": "Mozambique",
        "+95": "Myanmar",
        "+264": "Namibia",
        "+674": "Nauru",
        "+977": "Nepal",
        "+31": "Netherlands",
        "+64": "New Zealand",
        "+505": "Nicaragua",
        "+227": "Niger",
        "+234": "Nigeria",
        "+850": "North Korea",
        "+389": "North Macedonia",
        "+47": "Norway",
        "+968": "Oman",
        "+92": "Pakistan",
        "+680": "Palau",
        "+507": "Panama",
        "+675": "Papua New Guinea",
        "+595": "Paraguay",
        "+51": "Peru",
        "+63": "Philippines",
        "+48": "Poland",
        "+351": "Portugal",
        "+974": "Qatar",
        "+40": "Romania",
        "+7": "Russia",
        "+250": "Rwanda",
        "+1-869": "Saint Kitts and Nevis",
        "+1-758": "Saint Lucia",
        "+1-784": "Saint Vincent and the Grenadines",
        "+685": "Samoa",
        "+378": "San Marino",
        "+239": "Sao Tome and Principe",
        "+966": "Saudi Arabia",
        "+221": "Senegal",
        "+381": "Serbia",
        "+248": "Seychelles",
        "+232": "Sierra Leone",
        "+65": "Singapore",
        "+421": "Slovakia",
        "+386": "Slovenia",
        "+677": "Solomon Islands",
        "+252": "Somalia",
        "+27": "South Africa",
        "+82": "South Korea",
        "+211": "South Sudan",
        "+34": "Spain",
        "+94": "Sri Lanka",
        "+249": "Sudan",
        "+597": "Suriname",
        "+46": "Sweden",
        "+41": "Switzerland",
        "+963": "Syria",
        "+886": "Taiwan",
        "+992": "Tajikistan",
        "+255": "Tanzania",
        "+66": "Thailand",
        "+670": "Timor-Leste",
        "+228": "Togo",
        "+676": "Tonga",
        "+1-868": "Trinidad and Tobago",
        "+216": "Tunisia",
        "+993": "Turkmenistan",
        "+90": "Turkey",
        "+688": "Tuvalu",
        "+256": "Uganda",
        "+380": "Ukraine",
        "+971": "United Arab Emirates",
        "+44": "United Kingdom",
        "+1": "United States",
        "+598": "Uruguay",
        "+998": "Uzbekistan",
        "+678": "Vanuatu",
        "+58": "Venezuela",
        "+84": "Vietnam",
        "+967": "Yemen",
        "+260": "Zambia",
        "+263": "Zimbabwe"
    };
    // Function to update the country code based on the country selected
    function updateCountryCode() {
        const country = countrySelect.value;
        // Update the second select element to match the country code
        codeSelect.value = countryCodeMap[country] || ""; // Default to empty if no match
        console.log(countryCodeMap[country]);
    }
    function updateCountry() {
        const countryCode = codeSelect.value;
        // Update the second select element to match the country code
        countrySelect.value = swappedCountryCodeMap[countryCode] || ""; // Default to empty if no match   
    }
    // Listen for changes on the country select element
    countrySelect.addEventListener("change", updateCountryCode);
    codeSelect.addEventListener("change", updateCountry);
}


(0, (/*@__PURE__*/$parcel$interopDefault($5c802cafad583260$exports))).init({
    duration: 2000
});
let $35da740d59af89ba$var$menuexpand = false;
menu_btn.addEventListener("click", (e)=>{
    if ($35da740d59af89ba$var$menuexpand) {
        menu.classList.add("hidden");
        menu.classList.remove("block");
        e.target.classList.remove("fa-xmark");
        e.target.classList.add("fa-bars");
        $35da740d59af89ba$var$menuexpand = false;
    } else {
        menu.classList.remove("hidden");
        menu.classList.add("block");
        e.target.classList.add("fa-xmark");
        e.target.classList.remove("fa-bars");
        $35da740d59af89ba$var$menuexpand = true;
    }
});
function $35da740d59af89ba$var$router() {
    // Get the current path, defaulting to "/" if none is present
    const path = window.location.pathname.replace(/^\/+|\/+$/g, "") || "/";
    // Load content based on the path (root or specific page)
    $35da740d59af89ba$var$loadContent(path === "" || path === "/" ? "" : path);
    // Update the document title based on the path
    switch(path){
        case "/":
            document.title = "Ayurvedic treatment by Mediveda"; // Title for home page
            document.querySelector("#home-label").style.color = "#ffa16f";
            break;
        case "about":
            document.title = "Mediveda - About Us"; // Title for about page
            document.querySelector("#about-us-label").style.color = "#ffa16f";
            break;
        case "contact-us":
            document.title = "Mediveda - Contact Us"; // Title for contact page
            document.querySelector("#contact-label").style.color = "#ffa16f";
            break;
        case "admin":
            document.title = "Mediveda - Admin Login"; // Title for admin login page
            break;
        case "payment-qr":
            document.title = "Mediveda - Payement"; // Title for admin login page
            document.querySelector("#payment-label").style.color = "#ffa16f";
            break;
        default:
            document.title = "Mediveda - Diseases"; // Fallback title for unknown routes
            break;
    }
}
function $35da740d59af89ba$var$navigateTo(path) {
    history.pushState(null, null, path); // Update the URL without a page reload
    $35da740d59af89ba$var$router(); // Run the router function after navigation
}
window.addEventListener("popstate", $35da740d59af89ba$var$router);
window.addEventListener("load", $35da740d59af89ba$var$router);
function $35da740d59af89ba$var$loadContent(page) {
    const contentDiv = document.getElementById("content");
    // Define page mappings to the correct HTML files for each section
    const pageMap = {
        "about": "./pages/about.html",
        "contact-us": "./pages/contactus.html",
        "payment-qr": "./pages/payment.html",
        "adminlogin": "./admin/login.html",
        "azoospermia-ayurvedic-treatment": "./diseases/male-infertility/azoospermia.html",
        "epididymitis-ayurvedic-treatment": "./diseases/male-infertility/epididymitis.html",
        "funiculitis-ayurvedic-treatment": "./diseases/male-infertility/funiculitis.html",
        "hormonal-imbalances-ayurvedic-treatment": "./diseases/male-infertility/hormonal-imbalance.html",
        "oligospermia-ayurvedic-treatment": "./diseases/male-infertility/oligo.html",
        "orchitis-ayurvedic-treatment": "./diseases/male-infertility/orchitis.html",
        "retrograde-ejaculation-ayurvedic-treatment": "./diseases/male-infertility/retrograde-ejaculation.html",
        "undescended-testis-ayurvedic-treatment": "./diseases/male-infertility/undescended-testicles.html",
        "endometriosis-ayurvedic-treatment": "./diseases/female-infertility/Endometriosis.html",
        "hormonal-imbalance-female-ayurvedic-treatment": "./diseases/female-infertility/Hormonal-Imbalance.html",
        "irregular-menstruation-ayurvedic-treatment": "./diseases/female-infertility/Irregular-Menstruation.html",
        "ovulation-problems-ayurvedic-treatment": "./diseases/female-infertility/Ovulation-Problems.html",
        "pcod-ayurvedic-treatment": "./diseases/female-infertility/PCOD.html",
        "white-discharge-ayurvedic-treatment": "./diseases/female-infertility/White-Discharge.html",
        "pelvic-inflammatory-disease-ayurvedic-treatment": "./diseases/female-infertility/PID.html",
        "uterine-fibroids-ayurvedic-treatment": "./diseases/female-infertility/Uterine-Fibroids.html",
        "arthritis-ayurvedic-treatment": "./diseases/joint/Arthritis.html",
        "cervical-ayurvedic-treatment": "./diseases/joint/Cervical.html",
        "gout-ayurvedic-treatment": "./diseases/joint/Gout.html",
        "osteoarthritis-ayurvedic-treatment": "./diseases/joint/Osteoarthritis.html",
        "rheumatoid-arthritis-ayurvedic-treatment": "./diseases/joint/Rheumatoid_Arthritis.html",
        "sciatica-ayurvedic-treatment": "./diseases/joint/Sciatica.html",
        "spondylitis-ayurvedic-treatment": "./diseases/joint/Spondylitis.html",
        "acute-kidney-disorder-ayurvedic-treatment": "./diseases/kidney-disorders/AKD.html",
        "chronic-kidney-disorder-ayurvedic-treatment": "./diseases/kidney-disorders/CKD.html",
        "igA-nephropathy-ayurvedic-treatment": "./diseases/kidney-disorders/igA.html",
        "kidney-stones-ayurvedic-treatment": "./diseases/kidney-disorders/kidneystone.html",
        "polycystic-kidney-disorder-ayurvedic-treatment": "./diseases/kidney-disorders/PKD.html",
        "proteinuria-ayurvedic-treatment": "./diseases/kidney-disorders/proteinuria.html",
        "urinary-tract-obstruction-ayurvedic-treatment": "./diseases/kidney-disorders/UTO.html",
        "diabetes-ayurvedic-treatment": "./diseases/lifestyle-disorders/Diabetes.html",
        "erectile-dysfunction-ayurvedic-treatment": "./diseases/lifestyle-disorders/Erectile-Dysfunction.html",
        "gallbladder-stones-ayurvedic-treatment": "./diseases/lifestyle-disorders/GBS.html",
        "high-blood-pressure-ayurvedic-treatment": "./diseases/lifestyle-disorders/HTN.html",
        "hydrocele-ayurvedic-treatment": "./diseases/lifestyle-disorders/Hydrocele.html",
        "infection-ayurvedic-treatment": "./diseases/lifestyle-disorders/Infection.html",
        "piles-ayurvedic-treatment": "./diseases/lifestyle-disorders/Piles.html",
        "obesity-ayurvedic-treatment": "./diseases/lifestyle-disorders/Obesity.html",
        "premature-ejaculation-ayurvedic-treatment": "./diseases/lifestyle-disorders/Premature-Ejaculation.html",
        "urinary-tract-infection-ayurvedic-treatment": "./diseases/lifestyle-disorders/UTI.html",
        "varicocele-ayurvedic-treatment": "./diseases/lifestyle-disorders/Varicocele.html",
        "chronic-liver-disorder-ayurvedic-treatment": "./diseases/liver-disorders/CLD.html",
        "fatty-liver-ayurvedic-treatment": "./diseases/liver-disorders/fattyliver.html",
        "hepatitis-ayurvedic-treatment": "./diseases/liver-disorders/Hepatitis.html",
        "hepatomegaly-ayurvedic-treatment": "./diseases/liver-disorders/Hepatomegaly.html",
        "jaundice-ayurvedic-treatment": "./diseases/liver-disorders/jaundice.html",
        "liver-abscess-ayurvedic-treatment": "./diseases/liver-disorders/liverabscess.html",
        "liver-cirrhosis-ayurvedic-treatment": "./diseases/liver-disorders/livercirrhosis.html",
        "liver-fibrosis-ayurvedic-treatment": "./diseases/liver-disorders/liverfibrosis.html",
        "acne-ayurvedic-treatment": "./diseases/skin-disorders/Acne.html",
        "dermatitis-ayurvedic-treatment": "./diseases/skin-disorders/Dermatitis.html",
        "eczema-ayurvedic-treatment": "./diseases/skin-disorders/Eczema.html",
        "hives-ayurvedic-treatment": "./diseases/skin-disorders/hives.html",
        "psoriasis-ayurvedic-treatment": "./diseases/skin-disorders/Psoriasis.html",
        "vitiligo-ayurvedic-treatment": "./diseases/skin-disorders/Vitiligo.html",
        "warts-ayurvedic-treatment": "./diseases/skin-disorders/Warts.html",
        "terms-and-conditions": "./pages/termsandcondition.html",
        "privacy-policy": "./pages/privacypolicy.html",
        "": "./pages/main.html" // Home page
    };
    // Fetch the content based on the path, fallback to home if no match
    const pagePath = pageMap[page] || pageMap[""];
    console.log(pagePath);
    fetch(pagePath).then((response)=>response.text()).then((data)=>{
        if (pagePath === "./pages/about.html" || pagePath === "./pages/payment.html" || pagePath === "./pages/contactus.html" || pagePath === "./pages/termsandcondition.html" || pagePath === "./pages/privacypolicy.html") {
            contentDiv.innerHTML = data;
            document.getElementById("loader_main").classList.add("hidden");
            document.getElementById("loader_main").classList.remove("flex");
            document.documentElement.scrollTop = 0; // Scroll to top after loading content     
        } else if (pagePath === "./admin/login.html") {
            document.body.innerHTML = data;
            const loader = document.getElementById("loader");
            async function handleLogin(event) {
                event.preventDefault(); // Prevent the default form submission
                loader.classList.remove("hidden");
                loader.classList.add("flex");
                const username = document.getElementById("username").value;
                const password = document.getElementById("password").value;
                // console.log('Username:', username);
                // console.log('Password:', password);
                try {
                    const response = await fetch("https://mediveda.in/checkinputs.php", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            username: username,
                            password: password
                        })
                    });
                    console.log("Response status:", response.status);
                    const data = await response.json();
                    if (response.ok) window.location.href = data.redirect;
                    else {
                        document.getElementById("login-error-message").classList.remove("hidden");
                        document.getElementById("login-error-message").classList.add("block");
                        document.getElementById("login-error-message").textContent = data.message || "Login failed. Please try again.";
                    }
                } catch (error) {
                    console.error("Error:", error);
                    alert("An error occurred. Please try again.");
                } finally{
                    loader.classList.remove("flex");
                    loader.classList.add("hidden");
                }
            }
            document.getElementById("login-button").addEventListener("click", (event)=>{
                event.preventDefault();
                handleLogin(event);
            });
        } else if (pagePath === "./pages/main.html") {
            contentDiv.innerHTML = data;
            document.getElementById("loader_main").classList.add("hidden");
            document.getElementById("loader_main").classList.remove("flex");
            document.documentElement.scrollTop = 0; // Scroll to top after loading content
            (0, $d446e4ddd49a1d1e$export$e951be9369cbe7b1)(document.getElementById("target"), (0, $d446e4ddd49a1d1e$export$1bfdc901caf271be), 10000);
            (0, $d446e4ddd49a1d1e$export$e951be9369cbe7b1)(document.getElementById("target"), (0, $d446e4ddd49a1d1e$export$e6ef8bb00b365fd7), 25);
            $35da740d59af89ba$var$startScrolling();
            (0, $96c4986fcc3c58c1$export$2e2bcd8739ae039)();
            $35da740d59af89ba$var$operateAppointmentWindow();
            (0, $e73e8b8d99025aa5$export$2ac64a422d3a9b85)();
            (0, $9bec2756522502d7$export$2e2bcd8739ae039)();
            document.addEventListener("scroll", (0, $cecc98bcb04b03e8$export$bb046b82f0ab01e2));
            document.getElementsByClassName("disease");
        } else {
            contentDiv.innerHTML = data;
            document.getElementById("loader_main").classList.add("hidden");
            document.getElementById("loader_main").classList.remove("flex");
            document.documentElement.scrollTop = 0; // Scroll to top after loading content
            document.querySelector("#disease_menu").style.color = "#ffa16f";
            $35da740d59af89ba$var$operateAppointmentWindow();
            (0, $e73e8b8d99025aa5$export$2ac64a422d3a9b85)();
            document.title = page;
        }
    }).catch((error)=>{
        // Handle errors (e.g., page not found)
        contentDiv.innerHTML = "<p>Sorry, the page you're looking for doesn't exist.</p>";
        console.error("Error loading content:", error);
    });
}
//code for routing
// function loadContent(page) {
//   const contentDiv = document.getElementById("content");
//   if (page == "about") {
//     fetch("./pages/about.html")
//       .then((response) => response.text())
//       .then((data) => {
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//       });
//   } else if (page == "admin") {
//     fetch("./admin/login.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.body.innerHTML = data;
//         const loader = document.getElementById("loader");
//         async function handleLogin(event) {
//           event.preventDefault(); // Prevent the default form submission
//           loader.classList.remove("hidden");
//           loader.classList.add("flex");
//           const username = document.getElementById("username").value;
//           const password = document.getElementById("password").value;
//           // console.log('Username:', username);
//           // console.log('Password:', password);
//           try {
//             const response = await fetch("checkinputs.php", {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({ username, password }),
//             });
//             console.log("Response status:", response.status);
//             const data = await response.json(); 
//             if (response.ok) {
//               window.location.href = data.redirect; 
//             } else {
//               document
//                 .getElementById("login-error-message")
//                 .classList.remove("hidden");
//               document
//                 .getElementById("login-error-message")
//                 .classList.add("block");
//               document.getElementById("login-error-message").textContent =
//                 data.message || "Login failed. Please try again.";
//             }
//           } catch (error) {
//             console.error("Error:", error);
//             alert("An error occurred. Please try again.");
//           } finally {
//             loader.classList.remove("flex");
//             loader.classList.add("hidden");
//           }
//         }
//         document
//           .getElementById("login-button")
//           .addEventListener("click", (event) => {
//             event.preventDefault();
//             handleLogin(event);
//           });
//       });
//   } 
//   else if (page == "diseases/maleinfertility/azoospermia") {
//     fetch("./diseases/male-infertility/azoospermia.html")
//       .then((response) => response.text())
//       .then((data) => {document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/maleinfertility/oligospermia") {
//     fetch("./diseases/male-infertility/oligo.html")
//       .then((response) => response.text())
//       .then((data) => {document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "payment/QR_MD76XLMNS3298SLLSIEMN7") {
//     document.getElementById("loader_main").classList.add("flex");
//     document.getElementById("loader_main").classList.remove("hidden");
//     fetch("./pages/payment.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//       });
//   }
//   else if (page == "contact-us") {
//     fetch("./pages/contactus.html")
//       .then((response) => response.text())
//       .then((data) => {document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//       });
//   }
//   else if (page == "diseases/maleinfertility/epididymitis") {
//     fetch("./diseases/male-infertility/epididymitis.html")
//       .then((response) => response.text())
//       .then((data) => {document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/maleinfertility/orchitis") {
//     fetch("./diseases/male-infertility/orchitis.html")
//       .then((response) => response.text())
//       .then((data) => {document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/maleinfertility/funiculitis") {
//     fetch("./diseases/male-infertility/funiculitis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//       document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//   } else if (page == "diseases/maleinfertility/retrograde-ejaculation") {
//     fetch("./diseases/male-infertility/retrograde-ejaculation.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/maleinfertility/undescended-testicles") {
//     fetch("./diseases/male-infertility/undescended-testicles.html")
//       .then((response) => response.text())
//       .then((data) => {
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/maleinfertility/hormonal-imbalance") {
//     fetch("./diseases/male-infertility/hormonal-imbalance.html")
//       .then((response) => response.text())
//       .then((data) => {
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//       });
//   } else if (page == "diseases/liverdisorders/chronicliverdisease") {
//     fetch("./diseases/liver-disorders/CLD.html")
//       .then((response) => response.text())
//       .then((data) => {
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/liverdisorders/fattyliver") {
//     fetch("./diseases/liver-disorders/fattyliver.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/liverdisorders/liverfibrosis") {
//     fetch("./diseases/liver-disorders/liverfibrosis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/liverdisorders/livercirrhosis") {
//     fetch("./diseases/liver-disorders/livercirrhosis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/liverdisorders/jaundice") {
//     fetch("./diseases/liver-disorders/jaundice.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/liverdisorders/hepatitis") {
//     fetch("./diseases/liver-disorders/Hepatitis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/liverdisorders/heaptomegaly") {
//     fetch("./diseases/liver-disorders/Hepatomegaly.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   } else if (page == "diseases/liverdisorders/liverabscess") {
//     fetch("./diseases/liver-disorders/liverabscess.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }else if (page == "diseases/skindisorders/psoriasis") {
//     fetch("./diseases/skin-disorders/Psoriasis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/skindisorders/vitiligo") {
//     fetch("./diseases/skin-disorders/Vitiligo.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/skindisorders/acne") {
//     fetch("./diseases/skin-disorders/Acne.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/skindisorders/dermatitis") {
//     fetch("./diseases/skin-disorders/Dermatitis.html")
//       .then((response) => response.text())
//       .then((data) => {document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/skindisorders/hives") {
//     fetch("./diseases/skin-disorders/hives.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/skindisorders/warts") {
//     document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//     fetch("./diseases/skin-disorders/Warts.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/skindisorders/eczema") {
//     fetch("./diseases/skin-disorders/Eczema.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/kidneydisorders/pkd") {
//     fetch("./diseases/kidney-disorders/PKD.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/kidneydisorders/ckd") {
//     fetch("./diseases/kidney-disorders/CKD.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/kidneydisorders/akd") {
//     fetch("./diseases/kidney-disorders/AKD.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/kidneydisorders/iga") {
//     fetch("./diseases/kidney-disorders/igA.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/kidneydisorders/kidneystones") {
//     fetch("./diseases/kidney-disorders/kidneystone.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/kidneydisorders/uto") {
//     fetch("./diseases/kidney-disorders/UTO.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/kidneydisorders/proteinuria") {
//     fetch("./diseases/kidney-disorders/Proteinuria.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/jointneuralpain/arthritis") {
//     fetch("./diseases/joint/Arthritis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/jointneuralpain/gout") {
//     fetch("./diseases/joint/Gout.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
// else if (page == "diseases/jointneuralpain/sciatica") {
//   fetch("./diseases/joint/Sciatica.html")
//     .then((response) => response.text())
//     .then((data) => {
//       document.getElementById("loader_main").classList.add("hidden");
//       document.getElementById("loader_main").classList.remove("flex");
//       contentDiv.innerHTML = data;
//       document.documentElement.scrollTop = 0;
//       operateAppointmentWindow();
//         bookAppointment();
//     });
// }
//   else if (page == "diseases/jointneuralpain/rheumatoidarthritis") {
//     fetch("./diseases/joint/Rheumatoid_Arthritis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/jointneuralpain/osteoarthritis") {
//     fetch("./diseases/joint/Osteoarthritis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/jointneuralpain/spondylitis") {
//     fetch("./diseases/joint/Spondylitis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/jointneuralpain/spondylitis") {
//     fetch("./diseases/joint/Spondylitis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/jointneuralpain/cervical") {
//     fetch("./diseases/joint/Cervical.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/femaleinfertility/pcod") {
//     fetch("./diseases/female-infertility/PCOD.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/femaleinfertility/endometriosis") {
//     fetch("./diseases/female-infertility/Endometriosis.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/femaleinfertility/hormonalimbalance") {
//     fetch("./diseases/female-infertility/Hormonal-Imbalance.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/femaleinfertility/irregularmenstruation") {
//     fetch("./diseases/female-infertility/Irregular-Menstruation.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/femaleinfertility/uterinefibroids") {
//     fetch("./diseases/female-infertility/Uterine-Fibroids.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/femaleinfertility/ovulationproblems") {
//     fetch("./diseases/female-infertility/Ovulation-Problems.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/femaleinfertility/whitedischarge") {
//     fetch("./diseases/female-infertility/White-Discharge.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/femaleinfertility/pelvicinflammatorydisease") {
//     fetch("./diseases/female-infertility/PID.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/varicocele") {
//     fetch("./diseases/lifestyle-disorders/Varicocele.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/hydrocele") {
//     fetch("./diseases/lifestyle-disorders/Hydrocele.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/prematureejaculation") {
//     fetch("./diseases/lifestyle-disorders/Premature-Ejaculation.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/diabetes") {
//     fetch("./diseases/lifestyle-disorders/Diabetes.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/highbloodpressure") {
//     fetch("./diseases/lifestyle-disorders/HTN.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/infection") {
//     fetch("./diseases/lifestyle-disorders/Infection.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/uti") {
//     fetch("./diseases/lifestyle-disorders/UTI.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/obesity") {
//     fetch("./diseases/lifestyle-disorders/Obesity.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/erectiledysfunction") {
//     fetch("./diseases/lifestyle-disorders/Erectile-Dysfunction.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/piles") {
//     fetch("./diseases/lifestyle-disorders/Piles.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else if (page == "diseases/lifestyledisorders/gallbladderstone") {
//     fetch("./diseases/lifestyle-disorders/GBS.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         document.documentElement.scrollTop = 0;
//         operateAppointmentWindow();
//         bookAppointment();
//       });
//   }
//   else {
//     fetch("./pages/main.html")
//       .then((response) => response.text())
//       .then((data) => {
//         document.getElementById("loader_main").classList.add("hidden");
//         document.getElementById("loader_main").classList.remove("flex");
//         contentDiv.innerHTML = data;
//         startCounter(document.getElementById("target"), patientCounter, 10000);
//         startCounter(document.getElementById("target"), expCounter, 25);
//         startScrolling();
//         disease_router();
//         operateAppointmentWindow();
//         document.addEventListener("scroll", showGoToTop);
//         bookAppointment();
//         document.getElementsByClassName("disease")
//       });
//   }
// }
// function router() {
//   const hash = window.location.hash.substring(1) || "/";
//   loadContent(hash === "/" ? "" : hash);
//   switch (hash) {
//     case "/":
//       document.title = "Ayurvedic treatment by mediveda"; // Set to your desired title for home
//       break;
//     case "about":
//       document.title = "Mediveda-About Us"; // Set to your desired title for about
//       break;
//     case "contact":
//       document.title = "Mediveda-Contact Us"; // Set to your desired title for contact
//       break;
//     case "admin":
//       document.title = "Mediveda-Admin Login"; // Set to your desired title for contact
//       break;
//       default:
//       document.title = "Mediveda-Diseases"; // Fallback title for unmatched routes
//       break;
//   }
// }
// window.addEventListener("hashchange", router);
// window.addEventListener("load", router);
function $35da740d59af89ba$var$startScrolling() {
    let startX, endX, t_width = 0;
    let slides = document.querySelectorAll(".slide");
    let i = 0;
    const slider = document.querySelector("#slider");
    slider.addEventListener("touchstart", (e)=>{
        startX = e.touches[0].clientX;
    });
    slider.addEventListener("touchend", (e)=>{
        endX = e.changedTouches[0].clientX;
        // console.log( `this is endx ${endX}`)
        let difference = startX - endX;
        // console.log(difference)
        if (difference > 0) {
            if (i < 2) {
                t_width = t_width + 90;
                document.getElementsByClassName("slide")[i].style.transform = `translateX(-${t_width}vw)`;
                document.getElementsByClassName("slide")[i + 1].style.transform = `translateX(-${t_width}vw)`;
                if (i < 2) i++;
            }
        } else if (i > 0) {
            t_width = t_width - 90;
            document.getElementsByClassName("slide")[i].style.transform = `translateX(-${t_width}vw)`;
            document.getElementsByClassName("slide")[i - 1].style.transform = `translateX(-${t_width}vw)`;
            if (i > 0) i--;
        }
    });
}
const $35da740d59af89ba$var$disease_menu_overlay = document.getElementById("disease_menu_overlay");
const $35da740d59af89ba$var$disease_menu_item = document.getElementById("disease_menu_item");
const $35da740d59af89ba$var$disease_menu = document.getElementById("disease_menu");
document.getElementById("copyright-content").innerHTML = "Copyright " + new Date().getFullYear() + " \xa9 Mediveda. All Rights Reserved.";
$35da740d59af89ba$var$disease_menu.addEventListener("mouseenter", (e)=>{
    $35da740d59af89ba$var$disease_menu_overlay.classList.remove("hidden");
    $35da740d59af89ba$var$disease_menu_overlay.classList.add("block");
});
$35da740d59af89ba$var$disease_menu.addEventListener("mouseleave", ()=>{
    setTimeout(()=>{
        if (!$35da740d59af89ba$var$disease_menu_overlay.matches(":hover")) $35da740d59af89ba$var$disease_menu_overlay.classList.add("hidden");
    }, 200);
});
$35da740d59af89ba$var$disease_menu_overlay.addEventListener("mouseleave", (e)=>{
    $35da740d59af89ba$var$disease_menu_overlay.classList.remove("block");
    $35da740d59af89ba$var$disease_menu_overlay.classList.add("hidden");
});
const $35da740d59af89ba$var$disease_menu_btn_mob = document.getElementById("mobile-disease-menu");
const $35da740d59af89ba$var$disease_menu_mobile = document.getElementById("disease-menu-mobile");
let $35da740d59af89ba$var$menu_open = false;
$35da740d59af89ba$var$disease_menu_btn_mob.addEventListener("click", ()=>{
    if ($35da740d59af89ba$var$menu_open) {
        $35da740d59af89ba$var$disease_menu_mobile.classList.remove("block");
        $35da740d59af89ba$var$disease_menu_mobile.classList.add("hidden");
        document.getElementById("mobile-disease-menu-icon").classList.remove("fa-angle-up");
        document.getElementById("mobile-disease-menu-icon").classList.add("fa-angle-down");
        $35da740d59af89ba$var$menu_open = false;
    } else {
        $35da740d59af89ba$var$disease_menu_mobile.classList.remove("hidden");
        $35da740d59af89ba$var$disease_menu_mobile.classList.add("block");
        document.getElementById("mobile-disease-menu-icon").classList.remove("fa-angle-down");
        document.getElementById("mobile-disease-menu-icon").classList.add("fa-angle-up");
        $35da740d59af89ba$var$menu_open = true;
    }
});
const $35da740d59af89ba$var$categories = Array.from(document.getElementsByClassName("disease-category"));
const $35da740d59af89ba$var$sub_menus = Array.from(document.getElementsByClassName("disease-sub-menu"));
const $35da740d59af89ba$var$sub_menu_icons = Array.from(document.getElementsByClassName("disease-sub-menu-icon"));
$35da740d59af89ba$var$categories.forEach((cat, index)=>{
    cat.addEventListener("click", ()=>{
        const isOpen = $35da740d59af89ba$var$sub_menus[index].classList.contains("block");
        // Close all sub-menus first
        $35da740d59af89ba$var$sub_menus.forEach((sub_menu, idx)=>{
            if (idx !== index) {
                sub_menu.classList.add("hidden");
                sub_menu.classList.remove("block");
                $35da740d59af89ba$var$sub_menu_icons[idx].classList.remove("fa-angle-up");
                $35da740d59af89ba$var$sub_menu_icons[idx].classList.add("fa-angle-down");
            }
        });
        // Toggle the clicked sub-menu
        if (isOpen) {
            $35da740d59af89ba$var$sub_menus[index].classList.add("hidden");
            $35da740d59af89ba$var$sub_menus[index].classList.remove("block");
            $35da740d59af89ba$var$sub_menu_icons[index].classList.remove("fa-angle-up");
            $35da740d59af89ba$var$sub_menu_icons[index].classList.add("fa-angle-down");
        } else {
            $35da740d59af89ba$var$sub_menus[index].classList.add("block");
            $35da740d59af89ba$var$sub_menus[index].classList.remove("hidden");
            $35da740d59af89ba$var$sub_menu_icons[index].classList.remove("fa-angle-down");
            $35da740d59af89ba$var$sub_menu_icons[index].classList.add("fa-angle-up");
        }
    });
});
const $35da740d59af89ba$var$disease_link = Array.from(document.getElementsByClassName("disease-link"));
$35da740d59af89ba$var$disease_link.forEach((link)=>{
    link.addEventListener("click", ()=>{
        menu.classList.add("hidden");
        menu.classList.remove("block");
        menu_btn.classList.remove("fa-xmark");
        menu_btn.classList.add("fa-bars");
        $35da740d59af89ba$var$menuexpand = false;
    });
});
function $35da740d59af89ba$var$operateAppointmentWindow() {
    let appointment_window = document.getElementById("appointment-window");
    document.getElementById("appointment-btn").addEventListener("click", ()=>{
        appointment_window.classList.add("flex");
        appointment_window.classList.remove("hidden");
    });
    document.getElementById("appointment-btn2").addEventListener("click", ()=>{
        appointment_window.classList.add("flex");
        appointment_window.classList.remove("hidden");
    });
    document.querySelector("#apmnt-window-closer").addEventListener("click", ()=>{
        appointment_window.classList.add("hidden");
        appointment_window.classList.remove("flex");
    });
    window.addEventListener("click", (e)=>{
        if (e.target == appointment_window) {
            appointment_window.classList.add("hidden");
            appointment_window.classList.remove("flex");
        }
    });
}
const $35da740d59af89ba$var$disease_btns = Array.from(document.getElementsByClassName("disease"));
$35da740d59af89ba$var$disease_btns.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        $35da740d59af89ba$var$disease_menu_overlay.classList.add("hidden");
    });
});
(0, $7b2c18e151864ac9$export$7f1e8f51b61dd57)();


//# sourceMappingURL=index.232909cd.js.map
